// extracted by mini-css-extract-plugin
export default {"tabs":"RoomTabs_tabs__TLLVt","tab":"RoomTabs_tab__qEtJr","label":"RoomTabs_label__8GTyv","active":"RoomTabs_active__AZWoE"};